import React from 'react';

interface LoginBgProps {
  className?: string;
  width?: number;
  height?: number;
}

const LoginBgIcon = function LoginBgIcon({
  className,
  width,
  height,
}: LoginBgProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 1440 2400"
    >

      <g filter="url(#filter0_i_95_695)">
        <path d="M-349.373 333.109C-353.409 328.418 -350.817 321.116 -344.726 320.019L1430.58 0.196705C1435.49 -0.68729 1440 3.084 1440 8.06998V235V2128.32V2391.43C1440 2398.85 1430.77 2402.28 1425.94 2396.65L-349.373 333.109Z" fill="url(#paint0_linear_95_695)" fillOpacity="0.15" />
      </g>
      <defs>
        <filter id="filter0_i_95_695" x="-351.316" y="0.067749" width="1795.32" height="2399.38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="4" />
          <feGaussianBlur stdDeviation="16" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.596078 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_95_695" />
        </filter>
        <linearGradient id="paint0_linear_95_695" x1="1353.98" y1="276.826" x2="-383.339" y2="1626.19" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FDC5C5" />
          <stop offset="1" stopColor="#FEF1F1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

LoginBgIcon.defaultProps = {
  className: '',
  width: '100%',
  height: '100%',
};

export default LoginBgIcon;
